/**
 * Localization Dialog - Handles country and language selection dialogs
 */
if (typeof LocalizationDialog === 'undefined') {
class LocalizationDialog {
  constructor() {
    this.init();
  }

  init() {
    // Country dialogs
    document.querySelectorAll('[data-localization-opener]').forEach(button => {
      const position = button.dataset.localizationOpener;
      const dialog = document.getElementById(`LocalizationDialog-${position}`);
      if (dialog) {
        this.setupDialog(button, dialog, 'country_code');
      }
    });

    // Language dialogs
    document.querySelectorAll('[data-language-opener]').forEach(button => {
      const position = button.dataset.languageOpener;
      const dialog = document.getElementById(`LanguageDialog-${position}`);
      if (dialog) {
        this.setupDialog(button, dialog, 'locale_code');
      }
    });
  }

  setupDialog(button, dialog, inputName) {
    // Open dialog
    button.addEventListener('click', (e) => {
      e.preventDefault();
      dialog.showModal();
    });

    // Close button
    const closeBtn = dialog.querySelector('.localization-dialog__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        dialog.close();
      });
    }

    // Close on backdrop click
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });

    // Handle selection
    const links = dialog.querySelectorAll('.localization-dialog__link');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const value = link.dataset.value;
        const form = button.closest('localization-form')?.querySelector('form');
        if (form) {
          const input = form.querySelector(`input[name="${inputName}"]`);
          if (input) {
            input.value = value;
            form.submit();
          }
        }
        dialog.close();
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new LocalizationDialog());
} else {
  new LocalizationDialog();
}
} // End of duplicate protection check
